<template>
  <tooltip :text="action.tooltipText || object.tooltipText">
    <button
      class="btn btn-icon btn-light mr-2"
      :aria-label="action.tooltipText"
      :class="action.class"
      :style="{ color: actionColor }"
      @click.prevent="$emit(action.event, emitData)"
    >
      <i aria-hidden="true" :class="action.icon" />
      {{ action.name }}
    </button>
  </tooltip>
</template>

<script>
import Tooltip from '@/components/tooltip/Tooltip';
import { actionMixin } from '@/mixins/action';

// @vuese
// Pojedyncza akcja tabeli
// @group Table
export default {
  components: { Tooltip },
  mixins: [actionMixin],

  computed: {
    // @vuese
    // Dane do emitu
    emitData() {
      return this.action.id
        ? { object: { ...this.object, id: this.object.documentId }, action: this.action }
        : this.object;
    }
  }
};
</script>
